import BrandGallery from "./modules/BrandGallery/BrandGallery";
import ProductGallery from "./modules/ProductGallery/ProductGallery";
import MediaGallery from "./modules/MediaGallery/MediaGallery";
import MainBlock from "./modules/MainBlock/MainBlock";
import DetailsBlock from "./modules/ProductDetails/DetailsBlock";
import ProductDetails from "./modules/ProductDetails/ProductDetails";
import PriceBlock from "./modules/PriceBlock/PriceBlock";
import PriceServiceClient from "./services/PriceService/PriceServiceClient";
import PriceService from "./services/PriceService/PriceService";
import getProductTemplateDataset from "./utils/getProductTemplateDataset";
import SparePartsGallery from "./modules/SparePartsGallery/SparePartsGallery.js"
import SparePartsServiceClient from "./services/SparePartsService/SparePartsServiceClient";
//import ComparisonTable from "./modules/ComparisonTable/ComparisonTable";
import ComplementaryProductsGallery from "./modules/ComplementaryProductsGallery/ComplementaryProductsGallery.js"
import ComplementaryProductsServiceClient from "./services/ComplementaryProductsService/ComplementaryProductsServiceClient";
import StockService from "./services/StockService/StockService";
import StockServiceClient from "./services/StockService/StockServiceClient";
import StockBranchesServiceClient from "./services/StockService/StockBranchesServiceClient";
import StockBranchesService from "./services/StockService/StockBranchesService";
import SuburbServiceClient from "./services/SuburbService/SuburbServiceClient";
import ClearanceServiceClient from "./services/ClearanceService/ClearanceServiceClient";
import Badge from "./modules/Badge/Badge";
import StickyTabNavigation from "./modules/StickyTabNavigation/StickyTabNavigation";
import ModelViewer from "./modules/ModelViewer/ModelViewer";

const init = IntegrationService => {
  const templateContext = getProductTemplateDataset();

  const priceServiceClient = new PriceServiceClient(IntegrationService);
  const priceService = new PriceService(priceServiceClient, templateContext);
  const sparePartsServiceClient = new SparePartsServiceClient(IntegrationService);
  const complementaryProductsServiceClient = new ComplementaryProductsServiceClient(IntegrationService);
  const stockServiceClient = new StockServiceClient(IntegrationService);
  const stockService = new StockService(stockServiceClient, templateContext);
  const stockBranchesServiceClient = new StockBranchesServiceClient(IntegrationService);
  const stockBranchesService = new StockBranchesService(stockBranchesServiceClient);
  const suburbServiceVlient = new SuburbServiceClient(IntegrationService);
  const clearanceServiceClient = new ClearanceServiceClient(IntegrationService);

  BrandGallery.init();
  ProductGallery.init();
  MediaGallery.init();
  MainBlock.init();
  PriceBlock.init(priceService, templateContext, stockService, stockBranchesService, suburbServiceVlient, clearanceServiceClient);
  ProductDetails.init();
  DetailsBlock.init();
  SparePartsGallery.init(sparePartsServiceClient, templateContext);
  // ComparisonTable.init();
  ComplementaryProductsGallery.init(complementaryProductsServiceClient, templateContext);
  Badge.init();
  StickyTabNavigation.init('pdp-details__');
  ModelViewer.init();
};

export default { init };
